import AbstractStates from "../../states/AbstractStates";
import { inject } from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import DesktopUI from "./DesktopUI";
import DesktopDOM, { ELEMENT_IDS } from "./DesktopDOM";
import { BASE_ELEMENT_IDS } from "../BaseDOM";
import { ACTION_EVENTS } from "../UserAction";
import IUIActions from "../IUIActions";
import Wallet from "../../wallet/Wallet";
import IGame from "../../game/IGame";
import SystemConfig, { CONFIG_PARAMS, MODES } from "../../system/SystemConfig";
import DesktopUIController from "./DesktopUIController";
import { STATES } from "../../states/states";
import { canToggleFsMode } from "../../wallet/fsModeToggle";

export default class DesktopUIStates extends AbstractStates {
	protected ui: DesktopUI;
	protected dom: DesktopDOM;
	protected game: IGame;
	protected uiActions: IUIActions;
	protected wallet: Wallet;
	protected config: SystemConfig;
	protected disableAutostart: boolean;

	private forcespinTimeout: any;

	constructor(
		@inject(SERVICE_IDENTIFIER.UIController) uiController: DesktopUIController,
		@inject(SERVICE_IDENTIFIER.UI) ui: DesktopUI,
		@inject(SERVICE_IDENTIFIER.Game) game: IGame,
		@inject(SERVICE_IDENTIFIER.UIActions) uiActions: IUIActions,
		@inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig
	) {
		super();

		this.ui = ui;
		this.dom = ui.dom;
		this.game = game;
		this.uiActions = uiActions;
		this.wallet = wallet;
		this.config = config;
	}

	create() {}

	beforeSetState() {
		this.dom.onSetState();
		clearTimeout(this.forcespinTimeout);
	}

	stateInit(data) {
		document.getElementById("container").classList.add("state-init");

		let wintableControlsWrapper = document.getElementById(
			BASE_ELEMENT_IDS.WINTABLE_CONTROLS_WRAPPER
		);
		$(wintableControlsWrapper).hide();

		let btnSpin = document.getElementById(BASE_ELEMENT_IDS.BUTTON_SPIN);
		$(btnSpin).data("action", ACTION_EVENTS.ACTION_SPIN);
	}

	stateLoaded() {
		document.getElementById("container").classList.remove("state-init");
	}

	statePreinfo(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_PREINFO_CLOSE,
			ACTION_EVENTS.ACTION_SOUND_CHOOSE,
			ACTION_EVENTS.ACTION_HOME_BUTTON,
			ACTION_EVENTS.ACTION_PARAGRAPH_OPEN,
			ACTION_EVENTS.ACTION_HISTORY_OPEN,
			ACTION_EVENTS.ACTION_RESPONSIBLE_GAMING,
		]);

		this.dom.showSpinBtn(BASE_ELEMENT_IDS.BUTTON_PREINFO_CLOSE);

		let incBetBtn = document.getElementById(ELEMENT_IDS.BUTTON_BET_INC);
		let decBetBtn = document.getElementById(ELEMENT_IDS.BUTTON_BET_DEC);
		let incCoinBtn = document.getElementById(ELEMENT_IDS.BUTTON_COIN_INC);
		let decCoinBtn = document.getElementById(ELEMENT_IDS.BUTTON_COIN_DEC);
		let incLinesBtn = document.getElementById(ELEMENT_IDS.BUTTON_LINES_INC);
		let decLinesBtn = document.getElementById(ELEMENT_IDS.BUTTON_LINES_DEC);
		let maxBetBtn = document.getElementById(ELEMENT_IDS.BUTTON_MAX_BET);
		let autostartBtn = document.getElementById(ELEMENT_IDS.AUTOSTART_BTN);
		let infoBtn = document.getElementById(ELEMENT_IDS.BUTTON_INFO);
		let homeBtn = document.getElementById(ELEMENT_IDS.BUTTON_HOME);
		if(this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) homeBtn && $(homeBtn).prop("disabled", true);
		$([
			incBetBtn,
			decBetBtn,
			incCoinBtn,
			decCoinBtn,
			incLinesBtn,
			decLinesBtn,
			infoBtn,
			maxBetBtn,
			autostartBtn,
		]).prop("disabled", true);
	}

	stateSound(data) {}

	stateReady(data) {}

	stateIdle(data) {
		this.uiActions.unsetAllowedActions();
		if(this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
			this.uiActions.allowActions([
				ACTION_EVENTS.ACTION_AUTOSTART_CHOOSE,
				ACTION_EVENTS.ACTION_AUTOSTART_CLOSE,
				ACTION_EVENTS.ACTION_AUTOSTART_CONTINUE,
				ACTION_EVENTS.ACTION_AUTOSTART_OPEN,
				ACTION_EVENTS.ACTION_SETTINGS_OPEN,
				ACTION_EVENTS.ACTION_SPIN,
				ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST,
				ACTION_EVENTS.ACTION_FULLSCREEN_EXIT_REQUEST,
				ACTION_EVENTS.ACTION_PARAGRAPH_OPEN,
				ACTION_EVENTS.ACTION_PARAGRAPH_CLOSE,
				ACTION_EVENTS.ACTION_SOUND_TOGGLE,
				ACTION_EVENTS.ACTION_SKIP,
				ACTION_EVENTS.ACTION_INFO_TOGGLE
			])
		} else
			this.uiActions.allowAllActions(true)


		let incBetBtn = document.getElementById(ELEMENT_IDS.BUTTON_BET_INC);
		let decBetBtn = document.getElementById(ELEMENT_IDS.BUTTON_BET_DEC);
		let incCoinBtn = document.getElementById(ELEMENT_IDS.BUTTON_COIN_INC);
		let decCoinBtn = document.getElementById(ELEMENT_IDS.BUTTON_COIN_DEC);
		let incLinesBtn = document.getElementById(ELEMENT_IDS.BUTTON_LINES_INC);
		let decLinesBtn = document.getElementById(ELEMENT_IDS.BUTTON_LINES_DEC);
		let maxBetBtn = document.getElementById(ELEMENT_IDS.BUTTON_MAX_BET);
		let autostartBtn = document.getElementById(ELEMENT_IDS.AUTOSTART_BTN);
		let infoBtn = document.getElementById(ELEMENT_IDS.BUTTON_INFO);
		let homeBtn = document.getElementById(ELEMENT_IDS.BUTTON_HOME);
		let histBtn = document.getElementById(ELEMENT_IDS.BUTTON_HISTORY);
		let paraBtn = document.getElementById(ELEMENT_IDS.BUTTON_PARAGRAPH);
		let shield = document.getElementById(
			BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING
		);
		let freespins = document.getElementById(ELEMENT_IDS.BUTTON_FREESPINS);

		$([infoBtn, shield, freespins]).prop("disabled", false);
		$(autostartBtn).prop(
			"disabled",
			this.config.get(CONFIG_PARAMS.DISABLE_AUTOSTART)
		);
		$(maxBetBtn).prop("disabled", this.wallet.isBonus());

		homeBtn && $(homeBtn).prop("disabled", false);
		histBtn && $(histBtn).prop("disabled", false);
		paraBtn && $(paraBtn).prop("disabled", false);
		if(this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) homeBtn && $(homeBtn).prop("disabled", true);
		this.dom.refreshFsButtonLabel();
		if (this.wallet.isValidBonusBet() && this.wallet.getFreeSpins() > 0) {
			$(freespins).show();
		} else {
			$(freespins).hide();
		}
		$(freespins).prop(
			"disabled",
			!canToggleFsMode({
				state: STATES.IDLE,
				roundRunning: this.game.round.isRunning(),
				roundUnfinished: this.game.round.isUnfinished(),
				inGameFreespins: this.game.isInFreeSpins(),
				autostart: this.game.autostart.isAutostart(),
				freeSpins: this.wallet.getFreeSpins(),
				validBonusBet: this.wallet.isValidBonusBet(),
			})
		);

		if (
			this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY ||
			this.dom.freeSpinsShown
		) {
			$([
				incBetBtn,
				decBetBtn,
				incCoinBtn,
				decCoinBtn,
				incLinesBtn,
				decLinesBtn,
				maxBetBtn,
			]).prop("disabled", true);
			$(autostartBtn).prop(
				"disabled",
				this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY
			);
		} else {
			this.dom.allowBetButtons();
		}

		let autostart = this.game.autostart?.isAutostart();
		this.dom.showSpinBtn(
			autostart
				? BASE_ELEMENT_IDS.BUTTON_SPIN_AUTOSTART
				: BASE_ELEMENT_IDS.BUTTON_SPIN
		);
	}

	stateFsIdle(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowAction(ACTION_EVENTS.ACTION_SPIN);
		$("#" + ELEMENT_IDS.BUTTON_FREESPINS).prop("disabled", true);

		this.dom.showSpinBtn(BASE_ELEMENT_IDS.BUTTON_SPIN);
	}

	stateSpin(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_SKIP,
			ACTION_EVENTS.ACTION_FORCESTOP,
		]);

		// BUTTONS
		let incBet = document.getElementById(ELEMENT_IDS.BUTTON_BET_INC);
		let decBet = document.getElementById(ELEMENT_IDS.BUTTON_BET_DEC);
		let incCoin = document.getElementById(ELEMENT_IDS.BUTTON_COIN_INC);
		let decCoin = document.getElementById(ELEMENT_IDS.BUTTON_COIN_DEC);
		let incLines = document.getElementById(ELEMENT_IDS.BUTTON_LINES_INC);
		let decLines = document.getElementById(ELEMENT_IDS.BUTTON_LINES_DEC);
		let maxBet = document.getElementById(ELEMENT_IDS.BUTTON_MAX_BET);
		let autostartBtn = document.getElementById(ELEMENT_IDS.AUTOSTART_BTN);
		let info = document.getElementById(ELEMENT_IDS.BUTTON_INFO);
		let home = document.getElementById(ELEMENT_IDS.BUTTON_HOME);
		let history = document.getElementById(ELEMENT_IDS.BUTTON_HISTORY);
		let paragraph = document.getElementById(ELEMENT_IDS.BUTTON_PARAGRAPH);
		let shield = document.getElementById(
			BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING
		);
		let freespins = document.getElementById(ELEMENT_IDS.BUTTON_FREESPINS);

		$([
			info,
			incBet,
			decBet,
			incCoin,
			decCoin,
			maxBet,
			autostartBtn,
			incLines,
			decLines,
			shield,
			freespins,
		]).prop("disabled", true);

		home && $(home).prop("disabled", true);
		history && $(history).prop("disabled", true);
		paragraph && $(paragraph).prop("disabled", true);

		let autostart = this.game.autostart?.isAutostart();
		this.dom.showSpinBtn(
			autostart
				? BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART
				: BASE_ELEMENT_IDS.BUTTON_STOP
		);
	}

	stateSkip(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_SKIP,
			ACTION_EVENTS.ACTION_AUTOSTART_STOP,
		]);

		let autostart = this.game.autostart?.isAutostart();
		this.dom.showSpinBtn(
			autostart
				? BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART
				: BASE_ELEMENT_IDS.BUTTON_SKIP
		);
	}

	stateForcespin(data) {
		// Default FORCESPIN delay is 200ms, overriden by behavior..buttonBuffer if set
		let delay = 200;
		if (this.config.get(CONFIG_PARAMS.BEHAVIOR)?.reel?.spin?.buttonBuffer) {
			delay =
				this.config.get(CONFIG_PARAMS.BEHAVIOR).reel.spin.buttonBuffer * 1000;
		}

		this.forcespinTimeout = setTimeout(() => {
			this.uiActions.unsetAllowedActions();
			this.uiActions.allowActions([
				ACTION_EVENTS.ACTION_SPIN,
				ACTION_EVENTS.ACTION_AUTOSTART_STOP,
			]);

			let autostart = this.game.autostart?.isAutostart();
			this.dom.showSpinBtn(
				autostart
					? BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART
					: BASE_ELEMENT_IDS.BUTTON_SPIN
			);
		}, delay);
	}

	stateBonus(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([ACTION_EVENTS.ACTION_AUTOSTART_STOP]);

		let autostart = this.game.autostart?.isAutostart();
		if (autostart) {
			this.dom.showSpinBtn(BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART);
		} else {
			this.dom.showSpinBtn(BASE_ELEMENT_IDS.BUTTON_STOP, false);
		}
	}

	stateBonusWin(data) {
		this.stateBonus(data);
	}

	stateBonusWheel(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([ACTION_EVENTS.ACTION_BONUS_WHEEL_STOP]);

		$(`#${BASE_ELEMENT_IDS.BUTTON_STOP_BONUS_WHEEL}`).prop("disabled", true);
		this.dom.showSpinBtn(BASE_ELEMENT_IDS.BUTTON_STOP_BONUS_WHEEL);
	}

	stateSearching(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_AUTOSTART_STOP,
			ACTION_EVENTS.ACTION_FORCESTOP,
		]);
	}

	stateError(data) {
		this.uiActions.unsetAllowedActions();
	}
	stateJokerBonusWin(data: any) {
		this.uiActions.unsetAllowedActions();
		$(
			`#${ELEMENT_IDS.BUTTON_BET_INC}, 
			#${ELEMENT_IDS.BUTTON_BET_DEC}, 
			#${ELEMENT_IDS.BUTTON_COIN_INC}, 
			#${ELEMENT_IDS.BUTTON_COIN_DEC}, 
			#${ELEMENT_IDS.BUTTON_LINES_INC}, 
			#${ELEMENT_IDS.BUTTON_LINES_DEC}, 
			#${ELEMENT_IDS.BUTTON_MAX_BET}, 
			#${ELEMENT_IDS.AUTOSTART_BTN}, 
			#${ELEMENT_IDS.BUTTON_INFO}, 
			#${ELEMENT_IDS.BUTTON_HOME}, 
			#${ELEMENT_IDS.BUTTON_HISTORY}, 
			#${ELEMENT_IDS.BUTTON_PARAGRAPH}, 
			#${BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING}, 
			#${ELEMENT_IDS.BUTTON_FREESPINS}`
		).prop("disabled", true);
	}
}
